// extracted by mini-css-extract-plugin
export var lg = "_k-6";
export var md = "_k-5";
export var placeholderContainer = "_k-1";
export var placeholderIcon = "_k-2";
export var productImage = "_k-0";
export var sm = "_k-4";
export var xs = "_k-3";